import classNames from "classnames";
import { AutoFitCell, FixedCell } from "../../../components/tables/StandardTable";
import styled from "styled-components";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import { DateDisplay } from "../../../components";
import { useNavigate } from "react-router-dom";
import { MessagePriorities, ReminderStatuses } from "../../../helpers/constants";
import moment from "moment";
import EventsTableActionColumn from "./EventsTableActionColumn";

const EventsTableRowColumn = styled.td`
    padding: 0.6rem !important;
    vertical-align: middle;
    max-width: 50px;
    width: ${({ width }) => width}%;
`;

const StyledRow = styled.tr`
    background-color: ${({ isCancelled }) => isCancelled ? '#e9ecef' : 'transparent'};
    opacity: ${({ isCancelled }) => isCancelled ? 0.5 : 1};
    position: relative;
`

const ReminderPriorityCell = ({ value, isInfoOnly }) => {

    if (!value || isInfoOnly) return <span className="py-1 px-2">-</span>

    const className = [{
        'bg-priority-high text-priority-high': value === MessagePriorities.High,
        'bg-priority-medium text-priority-medium': value === MessagePriorities.Medium,
        'bg-priority-low text-priority-low': value === MessagePriorities.Low
    }];

    return <span className={classNames("badge py-1 px-2", className)}>
        {{
            [MessagePriorities.Low]: "Low",
            [MessagePriorities.Medium]: "Medium",
            [MessagePriorities.High]: "High"
        }[value]}
    </span>;
};

const ReminderDeadlineDateCell = ({ deadlineDate }) => {
    if (!deadlineDate) {
        return <span>-</span>
    }

    var date = moment(deadlineDate);
    let format = "DD/MM/YYYY HH:mm ";

    if (date.hours() === 0 && date.minutes() === 0) {
        format = "DD/MM/YYYY";
    }

    return <DateDisplay format={format} utc={false}>{date}</DateDisplay>;
};

const EventsTableRow = ({ data, index, style }) => {
    
    const { height } = style;

    const {gridData, setSelectedEvent, setSelectedViewEvent } = data || {gridData: [], setSelectedEvent : null};

    const navigate = useNavigate();

    // do not return a data row when the data has not yet been collected from the backend
    if (index >= gridData.length) {
        return <TableLoadingRow />;
    }

    const {
       id,
       type,
       deadlineDate,
       description,
       notes,
       project,
       projectId,
       createdBy,
       priority,
       masterAccountId,
       status
    } = gridData[index];
    

    const handleOpenProject = (e) => {
        if (e && typeof (e.preventDefault) === 'function') {
            e.preventDefault();
        }
        navigate(`/client/${masterAccountId}/projects?projectId=${projectId}`, { relative: 'route' });
    };

    return (
        <StyledRow key={`row-${index}`} isCancelled={status === ReminderStatuses.Cancelled}>
            {/* Project Name Display */}
            <EventsTableRowColumn className="text-truncate" width={12.5}>
                <a href={`/client/${masterAccountId}/projects?projectId=${projectId}`} onClick={handleOpenProject}>
                    <span>
                        {project}
                    </span>
                </a>
            </EventsTableRowColumn>
            {/* Deadline */}
            <EventsTableRowColumn className="text-truncate" width={7.5}>
                <ReminderDeadlineDateCell deadlineDate={deadlineDate} />
            </EventsTableRowColumn>
            {/* Type */}
            <EventsTableRowColumn className="text-truncate" width={7.5}>
                <span>{type}</span>
            </EventsTableRowColumn>
            {/* Description */}
            <EventsTableRowColumn className="text-truncate"  width={20}>
                <span>{description}</span>
            </EventsTableRowColumn>
            {/* Notes */}
            <EventsTableRowColumn className="text-truncate" width={37.5}>
                <span>{notes}</span>
            </EventsTableRowColumn>
            {/* Created By */}
            <EventsTableRowColumn className="text-truncate" width={10}>
                <span>{createdBy}</span>
            </EventsTableRowColumn>
            {/* Priority */}
            <EventsTableRowColumn width={6} className="align-middle text-center">
                <ReminderPriorityCell value={priority} />
            </EventsTableRowColumn>
            {/* Action */}
            <EventsTableActionColumn data={gridData[index]} setSelectedEvent={setSelectedEvent} setSelectedViewEvent={setSelectedViewEvent} />
        </StyledRow>
    );
}

export default EventsTableRow;